import { Children, ReactNode, useCallback, useMemo, useState } from 'react';
import { SwiperSlide } from 'swiper/react';

export type UseCarouselPlaceholdersOptions = { children: ReactNode; placeholder?: ReactNode };
export const useCarouselPlaceholders = ({
  children,
  placeholder,
}: UseCarouselPlaceholdersOptions) => {
  const [placeholderLength, setPlaceholderLength] = useState(0);
  const childrenSize = Children.count(children);
  const update = useCallback(
    (swiper) => {
      const {
        params: { slidesPerView },
      } = swiper;
      const safeSlidesPerView = typeof slidesPerView === 'number' ? slidesPerView : 0;
      const length = Math.max(safeSlidesPerView - childrenSize, 0);
      setPlaceholderLength(length);
    },
    [childrenSize]
  );
  const childrenWithPlaceholders = useMemo(
    () =>
      placeholder
        ? [
            ...Children.toArray(children),
            ...Array.from({ length: placeholderLength }).map((_, i) => (
              <SwiperSlide key={-i}>{placeholder}</SwiperSlide>
            )),
          ]
        : children,
    [children, placeholder, placeholderLength]
  );
  return {
    childrenWithPlaceholders,
    update,
  };
};
